import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTour } from "@/context/TourContext";

/**
 * v1.3 Presentation Mode polish — the permanent "relaunch the tour"
 * trigger, always visible in the header (never hidden inside a menu),
 * so a visitor who skipped or finished the welcome prompt can still
 * start the Guided Tour at any time. Renders nothing for real
 * (non-demo) users or roles with no tour steps.
 */
export const TourRelaunchPill = () => {
  const { enabled, startTour, relaunchRef } = useTour();
  if (!enabled) return null;

  return (
    <Button
      ref={relaunchRef}
      variant="outline"
      size="sm"
      onClick={startTour}
      className="hidden sm:inline-flex border-[hsl(var(--presentation)/0.35)] text-[hsl(var(--presentation))] hover:bg-[hsl(var(--presentation-soft))] hover:text-[hsl(var(--presentation))]"
      data-testid="tour-relaunch-button"
    >
      <Sparkles className="h-3.5 w-3.5" />
      <span className="hidden md:inline">See What Makes DriveDesk Hub Different</span>
      <span className="md:hidden">Tour</span>
    </Button>
  );
};
